import { Route, Routes } from "react-router-dom";
import VendorCreateScreen from "screens/App/CRM/CanUsers/Vendor/VendorCreateScreen";
import VendorDetailScreen from "screens/App/CRM/CanUsers/Vendor/VendorDetailScreen";
import VendorEditScreen from "screens/App/CRM/CanUsers/Vendor/VendorEditScreen";
import VendorListScreen from "screens/App/CRM/CanUsers/Vendor/VendorListScreen";

import { NotFoundScreen } from "screens/NotFoundScreen";

const VendorRouter = () => {
  return (
    <Routes>
      <Route path="/create" element={<VendorCreateScreen />} />
      <Route path="/:id/detail" element={<VendorDetailScreen />} />
      <Route path=":id/edit" element={<VendorEditScreen />} />
      <Route path="/list" element={<VendorListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default VendorRouter;
